module.exports = __webpack_public_path__ + "img/icon3.6764a722.png";